import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import DataTable from '../DataTable/DataTable';
import styles from './insuranceTable.module.scss';

const DraftInsurancesTable = (props) => {
  const {
    title,
    uri,
    columns,
    tblData,
    isLoading,
    getDraftInsuranceList,
    continueFromDraft,
  } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const user = useSelector((store) => store.userReducer.user, shallowEqual);
  const userId = user.id;
  const loadData = useCallback((params) => {
    if (userId) {
      dispatch(getDraftInsuranceList({ userId, params }));
    }
  }, [dispatch, getDraftInsuranceList, userId]);

  const loadContractFromDraft = useCallback((draft) => {
    dispatch(continueFromDraft(draft));
    history.push(uri);
  }, [continueFromDraft, dispatch, history, uri]);

  return (
    <div id={styles.tableContainer}>
      <div className={styles.table_title_row}>
        <div className="header">{t(title)}</div>
      </div>

      <DataTable
        data={tblData.data}
        totalCount={tblData.total}
        columns={columns}
        loading={isLoading}
        onParamsChanges={loadData}
        handleRowClick={loadContractFromDraft}
      />
    </div>
  );
};

DraftInsurancesTable.propTypes = {
  title: PropTypes.string,
  uri: PropTypes.string,
  columns: PropTypes.arrayOf(PropTypes.shape({})),
  tblData: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
    total: PropTypes.number,
  }),
  isLoading: PropTypes.bool,
  getDraftInsuranceList: PropTypes.func,
  continueFromDraft: PropTypes.func,
};

DraftInsurancesTable.defaultProps = {
  title: '',
  uri: '',
  columns: [],
  tblData: null,
  isLoading: false,
  getDraftInsuranceList: () => {},
  continueFromDraft: () => {},
};

export default DraftInsurancesTable;
